import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";
import { PageSpinner } from "../ui/Spinner";
import { ROLES } from "../../config/constants";
import { getDefaultAdminPath } from "../../utils/adminAccess";

export default function ProtectedRoute({ children, roles, moduleKey }) {
  const { isAuthenticated, role, modules, refreshToken } = useAuthStore();
  const location = useLocation();

  // If we have a refreshToken but aren't authenticated yet, session is restoring
  if (!isAuthenticated && refreshToken) {
    return <PageSpinner />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/" state={{ from: location, showLogin: true }} replace />
    );
  }

  if (roles && !roles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  // Module-level RBAC — meaningful for ADMIN (see RBAC_ADMIN_ROLES_PLAN.md)
  // and for CHANNEL_PARTNER (enabledModules on the partner's profile).
  // Technician keeps its fixed panel untouched. Redirect instead of
  // rendering a page shell that just 403s on every API call.
  if (moduleKey && role === ROLES.ADMIN && !(modules || []).includes(moduleKey)) {
    return <Navigate to={getDefaultAdminPath(modules)} replace />;
  }
  if (
    moduleKey &&
    role === ROLES.CHANNEL_PARTNER &&
    !(modules || []).includes(moduleKey)
  ) {
    return <Navigate to="/partner" replace />;
  }

  return children;
}
